export default "__VITE_ASSET__De1iTIb1__"